module.exports = __webpack_public_path__ + "img/allergy-peanut.16f6c445.png";